export const bannerOptions = {
    sx: {
        minHeight: { xs: 40, sm: 40, md: 40 },
    },
}